import { signIn } from "@common/auth/session";

/**
 * What a signed-out visitor sees in place of content that needs an account
 * (through RequireAuth), never a data-shaped empty state.
 */
export default function SignInPrompt() {
  return (
    <section className="notice">
      <p>Sign in with your kast-dev account to see this.</p>
      <button className="btn primary" onClick={signIn}>
        Sign in
      </button>
    </section>
  );
}
